import classnames from 'classnames';
import React, { ReactNode } from 'react';

const CSS = require('./PageContentBlock.module.scss');

interface PageContentBlockProps {
  children: ReactNode;
  className?: string;
  component?: string;
  bottomSpacing?: boolean;
  topSpacing?: boolean;
  enableContentVisibility?: boolean;
  [key: string]: any;
}

function PageContentBlock({
  children,
  className,
  component = 'div',
  bottomSpacing,
  topSpacing,
  enableContentVisibility,
  ...rest
}: PageContentBlockProps) {
  const classes = classnames(CSS.Block, {
    [CSS.BottomSpacing]: bottomSpacing,
    [CSS.TopSpacing]: topSpacing,
    [CSS.ContentVisibilityAuto]: enableContentVisibility,
    [className]: className,
  });

  return React.createElement(
    component,
    { className: classes, ...rest },
    children,
  );
}

export default PageContentBlock;
